<script lang="ts">
    import phones from 'src/components/main/about/components/our-goal/phones.svg'
</script>

<section class="our-goal">
    <div class="container">
        <div class="row">
            <div class="col-lg-6">
                <div class="intro-title">Our goals and innovation</div>
                <ul class="list">
                    <li>
                        <div class="number">01</div>
                        <div class="text-item">
                            <div class="title">We connect</div>
                            <div class="caption">Gaming economy with a real world, where users will be fully engaged.</div>
                        </div>
                    </li>
                    <li>
                        <div class="number">02</div>
                        <div class="text-item">
                            <div class="title">We aim to</div>
                            <div class="caption">Provide players with the most immersive gaming experience, hiding all difficult blockchain things under the hood.</div>
                        </div>
                    </li>
                    <li>
                        <div class="number">03</div>
                        <div class="text-item">
                            <div class="title">We want</div>
                            <div class="caption">Give users the games with real-life value.</div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="col-lg-6">
                <div class="phones-wrapper">
                    <img src="{phones}" class="phones" alt="phones">
                </div>
            </div>
        </div>
    </div>
</section>

<style>
    .our-goal {
        margin: 110px 0 0;
        padding-top: 150px;
    }

    .intro-title {
        font-family: 'Anton', sans-serif;
        font-size: 50px;
        font-weight: 400;
        color: white;
        margin: 0 0 100px;
        line-height: 1.3;
        letter-spacing: 0.04em;
        position: relative;
    }

    .intro-title span {
        color: transparent;
        -webkit-text-stroke: 1px white;
    }

    .list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .text-item {
        margin-left: 60px;
    }

    .title {
        font-family: 'Anton', sans-serif;
        margin-bottom: 20px;
        color: #FF5D1C;
        font-size: 25px;
        line-height: 27px;
        position: relative;
        letter-spacing: 1.2px;
        z-index: 2;
    }

    .caption {
        font-size: 20px;
        line-height: 1.5;
        color: #A0AEC0;
        max-width: 470px;
    }

    li {
        margin-bottom: 50px;
        display: flex;
    }

    .number {
        border: 1px solid #f14d2b;
        font-family: 'Anton', sans-serif;
        border-radius: 20px;
        font-size: 40px;
        line-height: normal;
        color: #594a40;
        width: 70px;
        min-width: 70px;
        height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #301d10;
        box-shadow: 10px 4px 30px rgba(255, 63, 50, 0.3);
    }

    .phones {
        margin: -50px auto 0;
        display: block;
        position: relative;
        z-index: 2;
    }

    .phones-wrapper {
        position: relative;
    }

    .phones-wrapper:before {
        content: "";
        border-radius: 620px;
        background: #FF6500;
        filter: blur(425px);
        position: absolute;
        width: 620px;
        height: 300px;
        top: 50%;
        transform: translate(0, -50%);
        z-index: 1;
    }

    @media(max-width: 1400px) {
        .caption {
            font-size: 18px;
        }

        .phones {
            margin: -50px 0 0 auto;
        }

        .phones-wrapper:before {
            width: 540px;
        }
    }

    @media(max-width: 1199px) {
        .phones-wrapper:before {
            width: 100%;
            margin-left: -100px;
        }
    }

    @media (max-width: 991px) {
        .our-goal {
            padding-top: 100px;
        }

        .intro-title {
            margin: 0 0 50px;
            letter-spacing: 2px;
            text-align: center;
        }

        .phones {
            margin: 0 auto;
            max-width: 330px;
        }

        .caption {
            max-width: 100%;
        }

        .title {
            margin-bottom: 15px;
            font-size: 22px;
            line-height: 1.5;
            letter-spacing: 1px;
        }

        .text-item {
            margin-left: 30px;
        }

        .phones-wrapper:before {
            width: 100%;
            margin: -100px 0 0 0;
            height: 100%;
            background: rgba(255, 101, 0, 0.7);
        }
    }

    @media (max-width: 767px) {
        .our-goal {
            margin: 62px 0 0;
            padding-top: 50px;
        }

        .intro-title {
            font-size: 40px;
            margin-bottom: 50px;
        }

        .caption {
            font-size: 15px;
            margin: 15px 0 0;
        }

        li {
            margin-bottom: 40px;
        }

        .title {
            font-size: 20px;
        }

        .text-item {
            margin-left: 20px;
        }

        .phones {
            padding: 0 40px;
        }
    }
</style>
